module.exports = "<ng-transclude></ng-transclude>\n\n<div class=\"am4-sticky-footer fade {{stickyFooterCtrl.footerModClass}}\" ng-show=\"stickyFooterCtrl.footerShow\" ng-class=\"{\n  'am4-sticky-footer--at-bottom': stickyFooterCtrl.stickyFooterAtBottom, 'am4-sticky-footer--static': stickyFooterCtrl.stickyFooterStatic\n}\">\n    <div class=\"am4-sticky-footer__content\">\n        <div class=\"am4-sticky-footer__content__container\"></div>\n    </div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/directives/stickyFooter.html
// module id = 394
// module chunks = 14